import React from 'react'

// Shared footer of the redesigned pages.

const BrandFooter = () => (
  <footer className="czb-footer">
    <div className="czb-wrap czb-footer-row">
      <div>
        <h2 className="czb-footer-title">Questions? We are happy to help.</h2>
        <div className="czb-contacts">
          <a href="mailto:support@colozoo.de">support@colozoo.de</a>
          <a href="https://www.instagram.com/colozoo.official/" target="_blank" rel="noopener noreferrer">Instagram</a>
          <a href="https://www.facebook.com/Colozoo.Official/" target="_blank" rel="noopener noreferrer">Facebook</a>
        </div>
      </div>
      <nav aria-label="Legal" className="czb-legal">
        <a href="/legal-notice">Legal notice</a>
        <a href="/privacy-policy">Privacy policy</a>
        <span>© Colozoo</span>
      </nav>
    </div>
  </footer>
)

export default BrandFooter
